import { Injectable, signal, computed } from '@angular/core';
import { en } from './i18n/en';
import { fr } from './i18n/fr';
import { es } from './i18n/es';

export type SupportedLang = 'en' | 'fr' | 'es';

export interface LangOption {
  code: SupportedLang;
  label: string;
}

const TRANSLATIONS: Record<SupportedLang, Record<string, string>> = { en, fr, es };
const STORAGE_KEY = 'app_language';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly langOptions: LangOption[] = [
    { code: 'en', label: 'English (US)' },
    { code: 'fr', label: 'French' },
    { code: 'es', label: 'Spanish' },
  ];

  readonly currentLang = signal<SupportedLang>(this.getStoredLang());
  readonly translations = computed(() => TRANSLATIONS[this.currentLang()]);

  setLanguage(lang: SupportedLang): void {
    this.currentLang.set(lang);
    // Guarded: localStorage/document don't exist during server-side prerendering
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, lang);
    if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', lang);
  }

  translate(key: string): string {
    return this.translations()[key] ?? key;
  }

  private getStoredLang(): SupportedLang {
    if (typeof localStorage === 'undefined') return 'en';
    const stored = localStorage.getItem(STORAGE_KEY) as SupportedLang;
    return stored && TRANSLATIONS[stored] ? stored : 'en';
  }
}